import React from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItem} from './AsideMenuItem'
import dashboardIcon from '../../../../_metronic/assets/icons/dashboard.png'
import bookingsIcon from '../../../../_metronic/assets/icons/bookings.png'
import eventsIcon from '../../../../_metronic/assets/icons/events.png'
import usersIcon from '../../../../_metronic/assets/icons/users.png'
import locationsIcon from '../../../../_metronic/assets/icons/locations.png'
import coachesIcon from '../../../../_metronic/assets/icons/coaches.png'
import voucherIcon from '../../../../_metronic/assets/icons/discount-coupon.png'
import staffIcon from '../../../../_metronic/assets/icons/employee.png'
import membershipIcon from '../../../../_metronic/assets/icons/membership.png'
import {useAuth} from '../../../../app/modules/auth'
export function AsideMenuMain() {
  const intl = useIntl()
  const {currentUser} = useAuth()
  type UserRole = 'super_admin' | 'facility_coordinator' | 'coach'
  // const userRole = useSelector((state: any) => state.auth.user?.role)
  const userRole: UserRole = currentUser?.role

  // Define menu items based on role
  const renderMenuItems = () => {
    switch (userRole) {
      // @ts-ignore
      case 'super_admin':
        return (
          <>
            <AsideMenuItem
              to='/dashboard'
              icon={dashboardIcon}
              title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
              fontIcon='bi-app-indicator'
            />
            <AsideMenuItem
              to='/bookings'
              icon={bookingsIcon}
              title={intl.formatMessage({id: 'MENU.BOOKINGS'})}
              fontIcon='bi-app-indicator'
            />
            <AsideMenuItem
              to='/events'
              icon={eventsIcon}
              title={intl.formatMessage({id: 'MENU.EVENTS'})}
              fontIcon='bi-app-indicator'
            />
            <AsideMenuItem
              to='/users'
              icon={usersIcon}
              title={intl.formatMessage({id: 'MENU.USERS'})}
              fontIcon='bi-app-indicator'
            />
            <AsideMenuItem
              to='/locations'
              icon={locationsIcon}
              title={intl.formatMessage({id: 'MENU.LOCATIONS'})}
              fontIcon='bi-app-indicator'
            />
            <AsideMenuItem
              to='/coaches'
              icon={coachesIcon}
              title={intl.formatMessage({id: 'MENU.COACHES'})}
              fontIcon='bi-app-indicator'
            />
            <AsideMenuItem
              to='/Staff'
              icon={staffIcon}
              title={intl.formatMessage({id: 'MENU.FACILITY_COORDINATOR'})}
              fontIcon='bi-app-indicator'
            />
            <AsideMenuItem
              to='/vouchers'
              icon={voucherIcon}
              title={intl.formatMessage({id: 'MENU.VOUCHERS'})}
              fontIcon='bi-app-indicator'
            />
            <AsideMenuItem
              to='/memberships'
              icon={membershipIcon}
              title={intl.formatMessage({id: 'MENU.MEMBERSHIPS'})}
              fontIcon='bi-app-indicator'
            />
          </>
        )
      // @ts-ignore
      case 'facility_coordinator':
        return (
          <>
            <AsideMenuItem
            to='/staff'
            icon={coachesIcon}
            title={intl.formatMessage({id: 'MENU.PROFILE'})}
            fontIcon='bi-app-indicator'
          />
            <AsideMenuItem
              to='/bookings'
              icon={bookingsIcon}
              title={intl.formatMessage({id: 'MENU.BOOKINGS'})}
              fontIcon='bi-app-indicator'
            />
            <AsideMenuItem
              to='/events'
              icon={eventsIcon}
              title={intl.formatMessage({id: 'MENU.EVENTS'})}
              fontIcon='bi-app-indicator'
            />
            {/* <AsideMenuItem
              to='/users'
              icon={usersIcon}
              title={intl.formatMessage({id: 'MENU.USERS'})}
              fontIcon='bi-app-indicator'
            /> */}
          </>
        )
      // @ts-ignore
      case 'coach':
        return (
          <AsideMenuItem
            to='/coaches'
            icon={coachesIcon}
            title={intl.formatMessage({id: 'MENU.COACH'})}
            fontIcon='bi-app-indicator'
          />
        )

      default:
        return null
    }
  }

  return <>{renderMenuItems()}</>
}
